import { next } from '@ember/runloop';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

import BoardsViewBoardPreviewRoute from 'webapp/routes/boards/view/board/preview';

import type Board from 'webapp/models-custom/board';

export default class BoardsViewBoardLimitationRoute extends BoardsViewBoardPreviewRoute {
	@service('billing') declare billingService: Service.Billing;
	@service('model-manager/sources') declare mmSourcesService: Service.ModelManager.Sources;
	@service('account') declare accountService: Service.Account;

	override afterModel(model: Board | undefined): void {
		super.afterModel(model);

		next(() => {
			if (model && this.accountService.isAdminButNotInClientSpace) {
				if (this.billingService.checkIfCan(BillingFeature.INSTANT_REFRESH, true)) {
					this.mmSourcesService.openEnableCustomDataUpdatePopup(
						model.sourcesObjs,
						false,
						'databoard_prevew_limitation',
					);
				}
			}
		});
	}
}
